// timezone.service.ts
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable, of } from 'rxjs';
import { ITimeZone } from './timezone-interface';
@Injectable({
    providedIn: 'root'
})
export class TimezoneService {

    private readonly _timeZones = [
        'UTC',
        'America/New_York',        // Eastern Time (US & Canada)
        'America/Chicago',         // Central Time (US & Canada)
        'America/Denver',          // Mountain Time (US & Canada)
        'America/Phoenix',         // Arizona
        'America/Los_Angeles',     // Pacific Time (US & Canada)
        'America/Anchorage',       // Alaska
        'America/Sao_Paulo',       // Brazil
        'America/Buenos_Aires',    // Argentina
        'Europe/London',           // UK
        'Europe/Paris',            // France
        'Europe/Berlin',           // Germany
        'Europe/Moscow',           // Russia
        'Europe/Istanbul',         // Turkey
        'Africa/Cairo',            // Egypt
        'Africa/Johannesburg',     // South Africa
        'Asia/Tokyo',              // Japan
        'Asia/Hong_Kong',          // Hong Kong
        'Asia/Singapore',          // Singapore
        'Asia/Seoul',              // South Korea
        'Asia/Shanghai',           // China
        'Asia/Kolkata',            // India
        'Asia/Dubai',              // UAE
        'Australia/Sydney',        // Australia (New South Wales)
        'Australia/Melbourne',     // Australia (Victoria)
        'Australia/Brisbane',      // Australia (Queensland)
        'Pacific/Auckland',        // New Zealand
        'Pacific/Fiji',            // Fiji
        'Pacific/Honolulu'         // Hawaii
    ];

    public getTimeZones(): Observable<ITimeZone[]> {
        const timeZonesWithOffsets = this._timeZones.map(timeZone => {
            const dateTime = DateTime.now().setZone(timeZone);
            const offset = dateTime.toFormat('ZZ');  // Get offset in format +00:00 or -00:00
            const offsetNumber = dateTime.offset / 60;  // Convert offset from minutes to hours

            return { timeZone: timeZone, offset: offset, offsetNumber: offsetNumber };
        });
        return of(timeZonesWithOffsets);
    }

    public getUserDefaultTimeZone(): ITimeZone {
        return {
            timeZone: DateTime.local().zoneName,
            offset: DateTime.local().toFormat('ZZ'),
            offsetNumber: DateTime.local().offset / 60
        };
    }

    public getTimeZoneOffset(timeZone: string): string {
        return DateTime.now().setZone(timeZone).toFormat('ZZ');
    }

    public getTimeZoneOffsetNumber(timeZone: string): number {
        return DateTime.now().setZone(timeZone).offset / 60;
    }
}
